import React from 'react';
import InternalLink from '../../input/InternalLink';

export type RecognizedEmailLoginPromptProps = {
  showLoginForm: () => void;
  loginRequired?: boolean;
};

const RecognizedEmailLoginPrompt: React.FC<RecognizedEmailLoginPromptProps> = ({
  showLoginForm,
  loginRequired = false,
}: RecognizedEmailLoginPromptProps) => {
  return (
    <div className="customer-login-prompt text-xs text-center m-2">
      Looks like you already have an account.{' '}
      {loginRequired ? 'You must ' : 'Do you want to '}
      <InternalLink className="text-xs" onClick={showLoginForm}>
        log in
      </InternalLink>
      {loginRequired ? ' before completing checkout' : '?'}
    </div>
  );
};

export default RecognizedEmailLoginPrompt;
